module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/id_5-7c4478b57912b755175bfb8e4d329ac1.jpg";